const kn = {
  common: {
    home: "ಮುಖಪುಟ",
    materials: "ಸಾಮಗ್ರಿಗಳು",
    rateCard: "ರೇಟ್ ಕಾರ್ಡ್",
    cart: "ಕಾರ್ಟ್",
    myBookings: "ನನ್ನ ಬುಕ್ಕಿಂಗ್‌ಗಳು",
    login: "ಲಾಗಿನ್",
    signup: "ಸೈನ್ ಅಪ್",
    dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    settings: "ಸೆಟ್ಟಿಂಗ್ಸ್",
    logout: "ಲಾಗ್‌ಔಟ್",
    save: "ಉಳಿಸಿ",
    loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
  },
  header: {
    brand: "ಮಿಸ್ತ್ರಿಬಜಾರ್",
  },
  settings: {
    title: "ಸೆಟ್ಟಿಂಗ್ಸ್",
    subtitle: "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್, ಭಾಷೆ, ವಿಳಾಸ ಮತ್ತು ಖಾತೆ ಸೆಟ್ಟಿಂಗ್ಸ್ ಅನ್ನು ನಿರ್ವಹಿಸಿ.",
    profileSection: "ಪ್ರೊಫೈಲ್",
    languageSection: "ಭಾಷೆ",
    addressSection: "ಉಳಿಸಿದ ವಿಳಾಸ",
    accountSection: "ಖಾತೆ",
    fullName: "ಪೂರ್ಣ ಹೆಸರು",
    phone: "ಫೋನ್ ಸಂಖ್ಯೆ",
    email: "ಇಮೇಲ್",
    city: "ನಗರ",
    preferredLanguage: "ಆದ್ಯತೆಯ ಭಾಷೆ",
    flatHouseNo: "ಫ್ಲಾಟ್ ನಂ / ಮನೆ ನಂ",
    streetArea: "ರಸ್ತೆ / ಪ್ರದೇಶ",
    state: "ರಾಜ್ಯ",
    country: "ದೇಶ",
    pincode: "ಪಿನ್ ಕೋಡ್",
    role: "ಪಾತ್ರ",
    uniqueId: "ಯೂನಿಕ್ ಐಡಿ",
    saveProfile: "ಪ್ರೊಫೈಲ್ ಉಳಿಸಿ",
    saveAddress: "ವಿಳಾಸ ಉಳಿಸಿ",
    accountDetails: "ಖಾತೆ ವಿವರಗಳು",
  },
  home: {
    heroTitle: "ಮಿಸ್ತ್ರಿಬಜಾರ್",
    heroText:
      "ಸೇವೆಗಳು ಬುಕ್ ಮಾಡಿ, ಸಾಮಗ್ರಿಗಳನ್ನು ಖರೀದಿಸಿ, ನಿಮ್ಮ ಮನೆ ಕಟ್ಟಿಸಿ, ಮತ್ತು ಸ್ಥಳೀಯ ಸಮನ್ವಯ, ಮರೆಮಾಚಿದ ವೆಚ್ಚಗಳು ಮತ್ತು ಅನಿಶ್ಚಿತ ವೇಳಾಪಟ್ಟಿಯ ತೊಂದರೆ ಕಡಿಮೆ ಮಾಡಿ.",
    buyMaterials: "ಸಾಮಗ್ರಿಗಳನ್ನು ಖರೀದಿಸಿ",
    buildYourHouse: "ನಿಮ್ಮ ಮನೆ ಕಟ್ಟಿಸಿ",
    exploreMembership: "ಸದಸ್ಯತ್ವ ನೋಡಿ",
    services: "ಸೇವೆಗಳು",
    about: "ನಮ್ಮ ಬಗ್ಗೆ",
    contactUs: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
    privacyPolicy: "ಗೌಪ್ಯತಾ ನೀತಿ",
    terms: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
  },
};

export default kn;